

export class SelectActiveWithVehicleCounterOutputData implements ISelectActiveWithVehicleCounterOutputData {
    /** The Reference id of the tbl_company_detail table */
    company_details_id!: number;
    /** The company name with 255 character limit */
    company_name!: string;
    /** The total vehicle count */
    vehicle_count!: number;

    constructor(data?: ISelectActiveWithVehicleCounterOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company_details_id = _data["company_details_id"];
            this.company_name = _data["company_name"];
            this.vehicle_count = _data["vehicle_count"];
        }
    }

    static fromJS(data: any): SelectActiveWithVehicleCounterOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new SelectActiveWithVehicleCounterOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company_details_id"] = this.company_details_id;
        data["company_name"] = this.company_name;
        data["vehicle_count"] = this.vehicle_count;
        return data; 
    }
}

export interface ISelectActiveWithVehicleCounterOutputData {
    /** The Reference id of the tbl_company_detail table */
    company_details_id: number;
    /** The company name with 255 character limit */
    company_name: string;
    /** The total vehicle count */
    vehicle_count: number;
}

